export default "__VITE_ASSET__DOZkYO6$__"